export default "__VITE_ASSET__BU7Sf4bi__"